import { Grid, Typography, Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation, Trans } from 'react-i18next'
import { DewiAccordion } from '@components/Accordion'
import { useMemo } from 'react'

const RootGrid = styled(Grid, { label: 'FAQ-rootGrid' })(({ theme }) => ({
  height: '100%',
}))

const FAQTitle = styled(Typography)(() => ({
  textAlign: "center"
}))

function FAQ() {
  const { t } = useTranslation()

  const accordionItems = useMemo(() => {
    const accordionItemObjects: any = t('faq.accordionItems', {
      returnObjects: true,
    })

    if (!accordionItemObjects) return []

    return Array.from(accordionItemObjects).map((item: any, index: any) => ({
      title: item.title,
      content: item.content,
      id: `panel${index + 1}`,
    }))
  }, [t])

  return (
    <RootGrid>
      <Stack spacing={4}>
        <FAQTitle variant="h2">
          <Trans i18nKey="faq.title" />
        </FAQTitle>
        <DewiAccordion items={accordionItems} />
      </Stack>
    </RootGrid>
  )
}

export default FAQ
